'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

export function AnchorScrollFix() {
  const pathname = usePathname();

  useEffect(() => {
    const hash = window.location.hash;
    const el = hash && document.getElementById(hash.replace('#', ''));
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
    }
  }, [pathname]);

  return <></>;
}
